import { useContext } from "react";

/* styles */
import style from "@styles/pdp/SizePicker.module.scss";

/* context */
import context from "@context/pdp";
import {
  setSize,
  setMouseoverSize,
  removeMouseoverSize,
} from "@context/pdp/actions";

/* utils */
import { sortSizes } from "@utils/detail";
import { useSizeInseamTranslation } from "@utils/use-size-translation";

export default function SizePicker() {
  const { state, dispatch } = useContext(context);

  const GetLabel = (value) => {
    const label = useSizeInseamTranslation(
      value.length >= 4 ? value.toLowerCase() : value,
    );
    return state.step.product.attributes.find((attr) => attr.type === "waist")
      ? state.step.product.attributes
          .filter((attr) => attr.type === "waist")[0]
          .options.find((attr) => attr.value.split("_")[0] === value)?.label //Split to manage Kids specific value format
      : label;
  };

  const getClassName = (sizesList) => {
    let className = style.sizePicker;
    if (
      sizesList.filter((s) => s.size.length > 4 && s.sizeKey !== "OS")
        .length === sizesList.length
    )
      className += ` ${style.sizePickerYears}`;
    return className;
  };

  const getItemClassName = (size, sizeKey, stock, catId) => {
    let className = style.sizePickerItem;

    const color = catId.split(":")[2];
    const sizeAvailableForInseam = state.step.product.hasInseam;

    const sizeHasInseamAvailable = state.step.product.originalVariants.find(
      (variant) =>
        (variant.attributes.waist === size ||
          variant.attributes.size === size) &&
        variant.attributes.color === color &&
        variant.productInventoryState === "InStock",
    )
      ? true
      : false;

    if (
      size === state.bundleConfiguration[state.step.product.partNumber]?.size
    ) {
      className += ` ${style.sizePickerItemSelected} `;
      className += ` ${style.sizePickerItemSelectedNoHover}`;
    }
    if (!stock && sizeAvailableForInseam === false) {
      className += ` ${style.sizePickerItemDisabled}`;
    }
    if (state.step.product.hasInseam && sizeHasInseamAvailable === false) {
      className += ` ${style.sizePickerItemDisabled}`;
    }
    if (sizeKey !== "OS") {
      className += ` ${style.sizePickerItemFixed}`;
    }
    return className;
  };

  const sizesList = state.step.product.hasInseam
    ? Object.values(
        state.step.product.originalVariants
          .filter((variant) =>
            variant.id.includes(
              state.step.product.id.substr(state.step.product.id.length - 3),
            ),
          )
          .reduce((acc, curr) => {
            const key = curr.id.split(":")[3];
            if (!acc[key]) acc[key] = [];
            acc[key].push(curr);
            return acc;
          }, {}),
      ).map((sizes) => {
        const size = {
          size: sizes[0].attributes.waist,
          inseamKey: sizes[0].attributes.inseam,
          stock: sizes.some((size) => size.productInventoryState === "InStock"),
          stockLeft: 0,
          catId: sizes[0].id,
          sizeKey: sizes[0].attributes.waist,
          display: sizes[0].attributes.waist,
        };
        return size;
      })
    : state.step.product.sizes;
  return (
    <div className={getClassName(sizesList)}>
      {sortSizes(sizesList).map(
        ({ size, sizeKey, display, stock, catId, stockLeft }) => (
          <div
            key={size}
            className={getItemClassName(size, sizeKey, stock, catId)}
            onClick={() =>
              setSize({ state, dispatch }, size, catId, display, stockLeft)
            }
            onMouseEnter={() =>
              setMouseoverSize(
                { dispatch },
                { stock, size, sizeKey, catId, stockLeft },
              )
            }
            onMouseLeave={() => removeMouseoverSize({ dispatch })}
          >
            {GetLabel(display)}
          </div>
        ),
      )}
    </div>
  );
}
